import React from 'react';
import { useBrandingColors } from '../../hooks/useBrandingColors';
import { generatePageNumbers } from '../vacancies/helpers';

interface ManagementPaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

export const ManagementPagination: React.FC<ManagementPaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange
}) => {
  const colors = useBrandingColors();
  const pageNumbers = generatePageNumbers(currentPage, totalPages);
  
  // Вычисляем диапазон отображаемых элементов
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  
  if (totalPages <= 1) {
    return null;
  }
  
  return (
    <div className="flex items-center justify-between w-full py-2">
      {/* Информация о количестве записей */}
      <div className="text-sm text-[#525866]">
        Показано {startItem}-{endItem} из {totalItems} записей
      </div>
      
      {/* Навигация по страницам */}
      <div className="flex items-center gap-1">
        {/* Кнопка "Предыдущая" */}
        <button
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
          className="flex items-center justify-center w-7 h-7 rounded-lg text-[#525866] hover:bg-[#f6f8fa] disabled:opacity-50 disabled:hover:bg-transparent disabled:cursor-not-allowed transition-colors"
          title="Предыдущая страница"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        
        {/* Номера страниц */}
        {pageNumbers.map((page, index) => (
          <React.Fragment key={index}>
            {page === '...' ? (
              <span className="flex items-center justify-center w-7 h-7 text-[#525866]">
                ...
              </span>
            ) : (
              <button
                onClick={() => onPageChange(page as number)}
                className={`flex items-center justify-center w-7 h-7 rounded-lg font-medium text-sm transition-colors ${
                  currentPage === page ? 'text-white' : 'text-[#525866] hover:bg-[#f6f8fa]'
                }`}
                style={currentPage === page ? { backgroundColor: colors.primary } : undefined}
                title={`Страница ${page}`}
              >
                {page}
              </button>
            )}
          </React.Fragment>
        ))}
        
        {/* Кнопка "Следующая" */}
        <button
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="flex items-center justify-center w-7 h-7 rounded-lg text-[#525866] hover:bg-[#f6f8fa] disabled:opacity-50 disabled:hover:bg-transparent disabled:cursor-not-allowed transition-colors"
          title="Следующая страница"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};
